import React from 'react'
import classNames from 'classnames'

import styles from '@components/icons/stars.module.scss'

const Star1 = ({ className, color, ...rest }) => {
  return (
    <svg
      viewBox="0 0 360 256.6"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(styles.star, styles['star--left'], className)}
      {...rest}
    >
      <polygon
        className="st2"
        points="151.8,20.1 159.3,0 167.3,20.1 183.8,20.1 170.8,33.1 178.8,54.1 158.3,45.6 139.9,54.6 146.8,35.1 137.8,22.1"
      />
    </svg>
  )
}

export default Star1
